import React from 'react'
import styles from './form-label.styles'
import injectSheet from 'react-jss'

const FormLabel = ({ classes, children, htmlFor, required }) => (
  <label className={classes.label} htmlFor={htmlFor}>
    {children} {required && '*'}
  </label>
)

export default injectSheet(styles)(FormLabel)
